//16、三孔 C
import makerjs from "makerjs";
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function ThreeHoles3(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D=inputParam.D,W=inputParam.W,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
 
   d = D*1*myZoom,
      w= W*1*myZoom,
      h= H*1*myZoom,
        x0 = X*1*myZoom,
        y0 = Y*1*myZoom;
        if(plate.models===undefined||plate.models===""){
            console.log("1111111111111111");
            plate.models={};
                    }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                        console.log("22222222222");
                        //cutPlate.models={};
                        cutPlate.models={};
                    }
                    if(markers.models===undefined||markers.models===""){            
                        console.log("333333333333");
                        markers.models={};
                    }
        /*
        d = D*1,
           w= W*1,
           h= H*1,
             x0 = X*1,
             y0 = Y*1;
             */
       if(d!==0){
         var TxtD="∮"+D;
        }
        if(h!==0){
         var TxtH=H;
        }
        if(w!==0){
         var TxtW=W;
        }
        if(x0!==0){          
        var TxtX=X;
        }
        if(y0!==0){          
         var TxtY=Y;
        }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;
  if(area==1){
    //画孔A位置孔
          //标记三孔 A位置孔右上
          var myThHolesARightup= new makerjs.models.Holes(d/2, [[xa, ya]]);
          var myThHolesMarkARightup = new makerjs.models.Square(0); //孔的原点       
          myThHolesMarkARightup.origin = [xa, ya];      
          var myThHolesWMarkARightup = new makerjs.models.Square(0);      
          myThHolesWMarkARightup.origin =[xa, ya];       
          var myThHolesXMarkARightup = new makerjs.models.Square(0);      
          myThHolesXMarkARightup.origin =[xa, ya];        
          var myThHolesYMarkARightup = new makerjs.models.Square(0);      
          myThHolesYMarkARightup.origin =[xa, ya];    
    /*****************************************************************************/ 
    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发X方向横向标线
    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([-x0,y0+markShiftTwo], [0, y0+markShiftTwo]));//从孔圆心出发X方向横向标线

    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([-x0,0], [0, 0]));//从孔圆心出发Y方向竖向标线
    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftFour]));//从孔圆心出发Y方向竖向标线
    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([0,y0], [0, y0+markShiftFour]));//从孔圆心出发Y方向竖向标线
    /*****************************************************************************/ 
    makerjs.model.addPath(myThHolesMarkARightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
    makerjs.model.addCaption(myThHolesMarkARightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
    /*****************************************************************************/   
    makerjs.model.addPath(myThHolesWMarkARightup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
    makerjs.model.addCaption(myThHolesWMarkARightup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
    /*****************************************************************************/  
    makerjs.model.addPath(myThHolesXMarkARightup, new makerjs.paths.Line([-x0,y0+markShiftTwo], [0, y0+markShiftTwo]));//X短标线
    makerjs.model.addCaption(myThHolesXMarkARightup, TxtX, [-x0,y0+markShiftFour], [0, y0+markShiftFour]);//X文字标注
    /*****************************************************************************/  
    makerjs.model.addPath(myThHolesYMarkARightup, new makerjs.paths.Line([0,0], [0, y0]));//X短标线
    makerjs.model.addCaption(myThHolesYMarkARightup, TxtY, [0-markShift,0], [0-markShift, y0]);//X文字标注
    /*****************************************************************************/  
    /*****************************************************************************/  
    /*****************************************************************************/ 
     //标记三孔A位置孔左下
     var myThHolesALeftdn= new makerjs.models.Holes(d/2, [[xa+w, ya]]);
          var myThHolesMarkALeftdn = new makerjs.models.Square(0); //孔的原点       
          myThHolesMarkALeftdn.origin = [xa+w, ya];       
          var myThHolesHMarkALeftdn = new makerjs.models.Square(0);      
          myThHolesHMarkALeftdn.origin = [xa+w, ya];  
    /*****************************************************************************/ 
    //makerjs.model.addPath(myThHolesMarkALeftdn, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发Y方向竖向标线
    /*****************************************************************************/ 
    makerjs.model.addPath(myThHolesMarkALeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
    makerjs.model.addCaption(myThHolesMarkALeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
    /*****************************************************************************/  
    makerjs.model.addPath(myThHolesHMarkALeftdn, new makerjs.paths.Line([0,-h], [0, 0]));//Y短标线
    makerjs.model.addCaption(myThHolesHMarkALeftdn, TxtH, [0-markShift,-h], [0-markShift, 0]);//Y文字标注
    /*****************************************************************************/ 
    /*****************************************************************************/ 
     //标记三孔 A位置孔右下
     var myThHolesARightdn= new makerjs.models.Holes(d/2, [[xa+w, ya-h]]);
          var myThHolesMarkARightdn = new makerjs.models.Square(0); //孔的原点       
          myThHolesMarkARightdn.origin = [xa+w, ya-h];
    /*****************************************************************************/ 
    /*****************************************************************************/ 
    makerjs.model.addPath(myThHolesMarkARightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
    makerjs.model.addCaption(myThHolesMarkARightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
    /*****************************************************************************/  
    /*****************************************************************************/
    plate.models["TypeHoles_ThreeHoles3_ALeftdn"+myHolesNum]=myThHolesALeftdn;
    cutPlate.models["TypeHoles_ThreeHoles3_ALeftdn"+myHolesNum]=myThHolesALeftdn;
    markers.models["TypeHoles_ThreeHoles3_ALeftdn"+myHolesNum]=myThHolesALeftdn;
    markers.models["TypeHoles_ThreeHoles3_MarkALeftdn"+myHolesNum]=myThHolesMarkALeftdn;
    markers.models["TypeHoles_ThreeHoles3_HMarkALeftdn"+myHolesNum]=myThHolesHMarkALeftdn;
    /*****************************************************************************/ 
    plate.models["TypeHoles_ThreeHoles3_ARightup"+myHolesNum]=myThHolesARightup;
    cutPlate.models["TypeHoles_ThreeHoles3_ARightup"+myHolesNum]=myThHolesARightup;
    markers.models["TypeHoles_ThreeHoles3_ARightup"+myHolesNum]=myThHolesARightup;
    markers.models["TypeHoles_ThreeHoles3_MarkARightup"+myHolesNum]=myThHolesMarkARightup;
    markers.models["TypeHoles_ThreeHoles3_XMarkARightup"+myHolesNum]=myThHolesXMarkARightup;
    markers.models["TypeHoles_ThreeHoles3_WMarkARightup"+myHolesNum]=myThHolesWMarkARightup;
    markers.models["TypeHoles_ThreeHoles3_YMarkARightup"+myHolesNum]=myThHolesYMarkARightup;
    /*****************************************************************************/ 
    plate.models["TypeHoles_ThreeHoles3_ARightdn"+myHolesNum]=myThHolesARightdn;
    cutPlate.models["TypeHoles_ThreeHoles3_ARightdn"+myHolesNum]=myThHolesARightdn;
    markers.models["TypeHoles_ThreeHoles3_ARightdn"+myHolesNum]=myThHolesARightdn;
    markers.models["TypeHoles_ThreeHoles3_MarkARightdn"+myHolesNum]=myThHolesMarkARightdn;
    /*****************************************************************************/ 
    /*****************************************************************************/ 
  
    }else if(area==2){
      //画孔B位置孔
            //标记三孔 B位置孔右上
            var myThHolesBRightup= new makerjs.models.Holes(d/2, [[xb-w/2, yb]]);
            var myThHolesMarkBRightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkBRightup.origin = [xb-w/2, yb];      
            var myThHolesWMarkBRightup = new makerjs.models.Square(0);      
            myThHolesWMarkBRightup.origin =[xb-w/2, yb];       
            var myThHolesYMarkBRightup = new makerjs.models.Square(0);      
            myThHolesYMarkBRightup.origin =[xb-w/2, yb];    
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkBRightup, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkBRightup, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkBRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkBRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkBRightup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkBRightup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesYMarkBRightup, new makerjs.paths.Line([0,0], [0, y0]));//X短标线
      makerjs.model.addCaption(myThHolesYMarkBRightup, TxtY, [0-markShift,0], [0-markShift, y0]);//X文字标注
      /*****************************************************************************/  
      /*****************************************************************************/  
      /*****************************************************************************/ 
       //标记三孔B位置孔左下
       var myThHolesBLeftdn= new makerjs.models.Holes(d/2, [[xb+w/2, yb]]);
            var myThHolesMarkBLeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkBLeftdn.origin = [xb+w/2, yb];       
            var myThHolesHMarkBLeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkBLeftdn.origin = [xb+w/2, yb];  
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkBLeftdn, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkBLeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkBLeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkBLeftdn, new makerjs.paths.Line([0,-h], [0, 0]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkBLeftdn, TxtH, [0-markShift,-h], [0-markShift, 0]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 B位置孔右下
       var myThHolesBRightdn= new makerjs.models.Holes(d/2, [[xb+w/2, yb-h]]);
            var myThHolesMarkBRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkBRightdn.origin = [xb+w/2, yb-h];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkBRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkBRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_BLeftdn"+myHolesNum]=myThHolesBLeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_BLeftdn"+myHolesNum]=myThHolesBLeftdn;
      markers.models["TypeHoles_ThreeHoles3_BLeftdn"+myHolesNum]=myThHolesBLeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkBLeftdn"+myHolesNum]=myThHolesMarkBLeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkBLeftdn"+myHolesNum]=myThHolesHMarkBLeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_BRightup"+myHolesNum]=myThHolesBRightup;
      cutPlate.models["TypeHoles_ThreeHoles3_BRightup"+myHolesNum]=myThHolesBRightup;
      markers.models["TypeHoles_ThreeHoles3_BRightup"+myHolesNum]=myThHolesBRightup;
      markers.models["TypeHoles_ThreeHoles3_MarkBRightup"+myHolesNum]=myThHolesMarkBRightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkBRightup"+myHolesNum]=myThHolesWMarkBRightup;
      markers.models["TypeHoles_ThreeHoles3_YMarkBRightup"+myHolesNum]=myThHolesYMarkBRightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_BRightdn"+myHolesNum]=myThHolesBRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_BRightdn"+myHolesNum]=myThHolesBRightdn;
      markers.models["TypeHoles_ThreeHoles3_BRightdn"+myHolesNum]=myThHolesBRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkBRightdn"+myHolesNum]=myThHolesMarkBRightdn;
      /*****************************************************************************/ 
      /*****************************************************************************/ 
    
    }else if(area==3){
      //画孔C位置孔
            //标记三孔 C位置孔右上
            var myThHolesCRightup= new makerjs.models.Holes(d/2, [[xc, yc]]);
            var myThHolesMarkCRightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkCRightup.origin = [xc, yc];      
            var myThHolesWMarkCRightup = new makerjs.models.Square(0);      
            myThHolesWMarkCRightup.origin =[xc, yc];       
            var myThHolesXMarkCRightup = new makerjs.models.Square(0);      
            myThHolesXMarkCRightup.origin =[xc, yc];       
            var myThHolesYMarkCRightup = new makerjs.models.Square(0);      
            myThHolesYMarkCRightup.origin =[xc, yc];    
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkCRightup, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkCRightup, new makerjs.paths.Line([-w,0], [0, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkCRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkCRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkCRightup, new makerjs.paths.Line([-w,0], [0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkCRightup, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesXMarkCRightup, new makerjs.paths.Line([0,0], [x0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesXMarkCRightup, TxtX, [0,0+markShift], [x0, 0+markShift]);//X文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesYMarkCRightup, new makerjs.paths.Line([0,0], [0, y0]));//X短标线
      makerjs.model.addCaption(myThHolesYMarkCRightup, TxtY, [0-markShift,0], [0-markShift, y0]);//X文字标注
      /*****************************************************************************/  
      /*****************************************************************************/  
      /*****************************************************************************/ 
       //标记三孔C位置孔左下
       var myThHolesCLeftdn= new makerjs.models.Holes(d/2, [[xc-w, yc]]);
            var myThHolesMarkCLeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkCLeftdn.origin = [xc-w, yc];       
            var myThHolesHMarkCLeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkCLeftdn.origin = [xc-w, yc];  
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkCLeftdn, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkCLeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkCLeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkCLeftdn, new makerjs.paths.Line([0,-h], [0, 0]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkCLeftdn, TxtH, [0-markShift,-h], [0-markShift, 0]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 C位置孔右下
       var myThHolesCRightdn= new makerjs.models.Holes(d/2, [[xc-w, yc-h]]);
            var myThHolesMarkCRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkCRightdn.origin = [xc-w, yc-h];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkCRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkCRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_CLeftdn"+myHolesNum]=myThHolesCLeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_CLeftdn"+myHolesNum]=myThHolesCLeftdn;
      markers.models["TypeHoles_ThreeHoles3_CLeftdn"+myHolesNum]=myThHolesCLeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkCLeftdn"+myHolesNum]=myThHolesMarkCLeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkCLeftdn"+myHolesNum]=myThHolesHMarkCLeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_CRightup"+myHolesNum]=myThHolesCRightup;
      cutPlate.models["TypeHoles_ThreeHoles3_CRightup"+myHolesNum]=myThHolesCRightup;
      markers.models["TypeHoles_ThreeHoles3_CRightup"+myHolesNum]=myThHolesCRightup;
      markers.models["TypeHoles_ThreeHoles3_MarkCRightup"+myHolesNum]=myThHolesMarkCRightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkCRightup"+myHolesNum]=myThHolesWMarkCRightup;
      markers.models["TypeHoles_ThreeHoles3_XMarkCRightup"+myHolesNum]=myThHolesXMarkCRightup;
      markers.models["TypeHoles_ThreeHoles3_YMarkCRightup"+myHolesNum]=myThHolesYMarkCRightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_CRightdn"+myHolesNum]=myThHolesCRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_CRightdn"+myHolesNum]=myThHolesCRightdn;
      markers.models["TypeHoles_ThreeHoles3_CRightdn"+myHolesNum]=myThHolesCRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkCRightdn"+myHolesNum]=myThHolesMarkCRightdn;
      /*****************************************************************************/ 
      /*****************************************************************************/ 
    
    }else if(area==4){
      //画孔D位置孔
            //标记三孔 D位置孔右上
            var myThHolesDRightup= new makerjs.models.Holes(d/2, [[xd, yd-h/2]]);
            var myThHolesMarkDRightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkDRightup.origin = [xd, yd-h/2];      
            var myThHolesWMarkDRightup = new makerjs.models.Square(0);      
            myThHolesWMarkDRightup.origin =[xd, yd-h/2];       
            var myThHolesXMarkDRightup = new makerjs.models.Square(0);      
            myThHolesXMarkDRightup.origin =[xd, yd-h/2];     
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkDRightup, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkDRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkDRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkDRightup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkDRightup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesXMarkDRightup, new makerjs.paths.Line([-x0,0], [0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesXMarkDRightup, TxtX, [-x0,0+markShift], [0,0+markShift]);//X文字标注
      /*****************************************************************************/  
       //标记三孔D位置孔左下
       var myThHolesDLeftdn= new makerjs.models.Holes(d/2, [[xd+w, yd-h/2]]);
            var myThHolesMarkDLeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkDLeftdn.origin = [xd+w, yd-h/2];       
            var myThHolesHMarkDLeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkDLeftdn.origin = [xd+w, yd-h/2];  
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkDLeftdn, new makerjs.paths.Line([0,0], [0, h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkDLeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkDLeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkDLeftdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkDLeftdn, TxtH, [0-markShift,0], [0-markShift, h]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 D位置孔右下
       var myThHolesDRightdn= new makerjs.models.Holes(d/2, [[xd+w, yd+h/2]]);
            var myThHolesMarkDRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkDRightdn.origin = [xd+w, yd+h/2];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkDRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkDRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_DLeftdn"+myHolesNum]=myThHolesDLeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_DLeftdn"+myHolesNum]=myThHolesDLeftdn;
      markers.models["TypeHoles_ThreeHoles3_DLeftdn"+myHolesNum]=myThHolesDLeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkDLeftdn"+myHolesNum]=myThHolesMarkDLeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkDLeftdn"+myHolesNum]=myThHolesHMarkDLeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_DRightup"+myHolesNum]=myThHolesDRightup;
      cutPlate.models["TypeHoles_ThreeHoles3_DRightup"+myHolesNum]=myThHolesDRightup;
      markers.models["TypeHoles_ThreeHoles3_DRightup"+myHolesNum]=myThHolesDRightup;
      markers.models["TypeHoles_ThreeHoles3_MarkDRightup"+myHolesNum]=myThHolesMarkDRightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkDRightup"+myHolesNum]=myThHolesWMarkDRightup;
      markers.models["TypeHoles_ThreeHoles3_XMarkDRightup"+myHolesNum]=myThHolesXMarkDRightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_DRightdn"+myHolesNum]=myThHolesDRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_DRightdn"+myHolesNum]=myThHolesDRightdn;
      markers.models["TypeHoles_ThreeHoles3_DRightdn"+myHolesNum]=myThHolesDRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkDRightdn"+myHolesNum]=myThHolesMarkDRightdn;
      /*****************************************************************************/
    }else if(area==5){
      //画孔E位置孔
            //标记三孔 E位置孔右上
            var myThHolesERightup= new makerjs.models.Holes(d/2, [[xe-w/2, ye-h/2]]);
            var myThHolesMarkERightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkERightup.origin = [xe-w/2, ye-h/2];      
            var myThHolesWMarkERightup = new makerjs.models.Square(0);      
            myThHolesWMarkERightup.origin =[xe-w/2, ye-h/2];    
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkERightup, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkERightup, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkERightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkERightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkERightup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkERightup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
      /*****************************************************************************/  
       //标记三孔E位置孔左下
       var myThHolesELeftdn= new makerjs.models.Holes(d/2, [[xe+w/2, ye-h/2]]);
            var myThHolesMarkELeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkELeftdn.origin = [xe+w/2, ye-h/2];       
            var myThHolesHMarkELeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkELeftdn.origin = [xe+w/2, ye-h/2];  
      /*****************************************************************************/ 
      //makerjs.model.addPath(myThHolesMarkELeftdn, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkELeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkELeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkELeftdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkELeftdn, TxtH, [0-markShift,0], [0-markShift, h]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 E位置孔右下
       var myThHolesERightdn= new makerjs.models.Holes(d/2, [[xe+w/2, ye+h/2]]);
            var myThHolesMarkERightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkERightdn.origin = [xe+w/2, ye+h/2];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkERightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkERightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_ELeftdn"+myHolesNum]=myThHolesELeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_ELeftdn"+myHolesNum]=myThHolesELeftdn;
      markers.models["TypeHoles_ThreeHoles3_ELeftdn"+myHolesNum]=myThHolesELeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkELeftdn"+myHolesNum]=myThHolesMarkELeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkELeftdn"+myHolesNum]=myThHolesHMarkELeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_ERightup"+myHolesNum]=myThHolesERightup;
      cutPlate.models["TypeHoles_ThreeHoles3_ERightup"+myHolesNum]=myThHolesERightup;
      markers.models["TypeHoles_ThreeHoles3_ERightup"+myHolesNum]=myThHolesERightup;
      markers.models["TypeHoles_ThreeHoles3_MarkERightup"+myHolesNum]=myThHolesMarkERightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkERightup"+myHolesNum]=myThHolesWMarkERightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_ERightdn"+myHolesNum]=myThHolesERightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_ERightdn"+myHolesNum]=myThHolesERightdn;
      markers.models["TypeHoles_ThreeHoles3_ERightdn"+myHolesNum]=myThHolesERightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkERightdn"+myHolesNum]=myThHolesMarkERightdn;
      /*****************************************************************************/ 
      /*****************************************************************************/ 
    
    }else if(area==6){
      //画孔F位置孔
            //标记三孔 F位置孔右上
            var myThHolesFRightup= new makerjs.models.Holes(d/2, [[xf, yf-h/2]]);
            var myThHolesMarkFRightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkFRightup.origin = [xf, yf-h/2];      
            var myThHolesWMarkFRightup = new makerjs.models.Square(0);      
            myThHolesWMarkFRightup.origin =[xf, yf-h/2];       
            var myThHolesXMarkFRightup = new makerjs.models.Square(0);      
            myThHolesXMarkFRightup.origin =[xf, yf-h/2];    
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkFRightup, new makerjs.paths.Line([0,0], [x0, 0]));//从孔圆心出发X方向横向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkFRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkFRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkFRightup, new makerjs.paths.Line([-w,0], [0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkFRightup, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesXMarkFRightup, new makerjs.paths.Line([0,0], [x0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesXMarkFRightup, TxtX, [0,0+markShift], [x0, 0+markShift]);//X文字标注
      /*****************************************************************************/ 
       //标记三孔F位置孔左下
       var myThHolesFLeftdn= new makerjs.models.Holes(d/2, [[xf-w, yf-h/2]]);
            var myThHolesMarkFLeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkFLeftdn.origin = [xf-w, yf-h/2];       
            var myThHolesHMarkFLeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkFLeftdn.origin = [xf-w, yf-h/2];  
      /*****************************************************************************/ 
     // makerjs.model.addPath(myThHolesMarkFLeftdn, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkFLeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkFLeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkFLeftdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkFLeftdn, TxtH,[0-markShift,0], [0-markShift, h]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 F位置孔右下
       var myThHolesFRightdn= new makerjs.models.Holes(d/2, [[xf-w, yf+h/2]]);
            var myThHolesMarkFRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkFRightdn.origin = [xf-w, yf+h/2];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkFRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkFRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_FLeftdn"+myHolesNum]=myThHolesFLeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_FLeftdn"+myHolesNum]=myThHolesFLeftdn;
      markers.models["TypeHoles_ThreeHoles3_FLeftdn"+myHolesNum]=myThHolesFLeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkFLeftdn"+myHolesNum]=myThHolesMarkFLeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkFLeftdn"+myHolesNum]=myThHolesHMarkFLeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_FRightup"+myHolesNum]=myThHolesFRightup;
      cutPlate.models["TypeHoles_ThreeHoles3_FRightup"+myHolesNum]=myThHolesFRightup;
      markers.models["TypeHoles_ThreeHoles3_FRightup"+myHolesNum]=myThHolesFRightup;
      markers.models["TypeHoles_ThreeHoles3_MarkFRightup"+myHolesNum]=myThHolesMarkFRightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkFRightup"+myHolesNum]=myThHolesWMarkFRightup;
      markers.models["TypeHoles_ThreeHoles3_XMarkFRightup"+myHolesNum]=myThHolesXMarkFRightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_FRightdn"+myHolesNum]=myThHolesFRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_FRightdn"+myHolesNum]=myThHolesFRightdn;
      markers.models["TypeHoles_ThreeHoles3_FRightdn"+myHolesNum]=myThHolesFRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkFRightdn"+myHolesNum]=myThHolesMarkFRightdn;
      /*****************************************************************************/ 
      /*****************************************************************************/ 
    
    }else if(area==7){
      //画孔G位置孔
            //标记三孔 G位置孔右上
            var myThHolesGRightup= new makerjs.models.Holes(d/2, [[xg, yg]]);
            var myThHolesMarkGRightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkGRightup.origin = [xg, yg];      
            var myThHolesWMarkGRightup = new makerjs.models.Square(0);      
            myThHolesWMarkGRightup.origin =[xg, yg];       
            var myThHolesXMarkGRightup = new makerjs.models.Square(0);      
            myThHolesXMarkGRightup.origin =[xg, yg];       
            var myThHolesYMarkGRightup = new makerjs.models.Square(0);      
            myThHolesYMarkGRightup.origin =[xg, yg];    
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkGRightup, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkGRightup, new makerjs.paths.Line([-x0,0], [0,0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkGRightup, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkGRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkGRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkGRightup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkGRightup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesXMarkGRightup, new makerjs.paths.Line([-x0,0], [0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesXMarkGRightup, TxtX, [-x0,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesYMarkGRightup, new makerjs.paths.Line([0,0], [0, -y0]));//X短标线
      makerjs.model.addCaption(myThHolesYMarkGRightup, TxtY, [0-markShift,-y0], [0-markShift, 0]);//X文字标注
      /*****************************************************************************/  
       //标记三孔G位置孔左下
       var myThHolesGLeftdn= new makerjs.models.Holes(d/2, [[xg+w, yg]]);
            var myThHolesMarkGLeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkGLeftdn.origin = [xg+w, yg];       
            var myThHolesHMarkGLeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkGLeftdn.origin = [xg+w, yg];  
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkGLeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkGLeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkGLeftdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkGLeftdn, TxtH, [0-markShift,0], [0-markShift, h]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 G位置孔右下
       var myThHolesGRightdn= new makerjs.models.Holes(d/2, [[xg+w, yg+h]]);
            var myThHolesMarkGRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkGRightdn.origin = [xg+w, yg+h];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkGRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkGRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_GLeftdn"+myHolesNum]=myThHolesGLeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_GLeftdn"+myHolesNum]=myThHolesGLeftdn;
      markers.models["TypeHoles_ThreeHoles3_GLeftdn"+myHolesNum]=myThHolesGLeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkGLeftdn"+myHolesNum]=myThHolesMarkGLeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkGLeftdn"+myHolesNum]=myThHolesHMarkGLeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_GRightup"+myHolesNum]=myThHolesGRightup;
      cutPlate.models["TypeHoles_ThreeHoles3_GRightup"+myHolesNum]=myThHolesGRightup;
      markers.models["TypeHoles_ThreeHoles3_GRightup"+myHolesNum]=myThHolesGRightup;
      markers.models["TypeHoles_ThreeHoles3_MarkGRightup"+myHolesNum]=myThHolesMarkGRightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkGRightup"+myHolesNum]=myThHolesWMarkGRightup;
      markers.models["TypeHoles_ThreeHoles3_XMarkGRightup"+myHolesNum]=myThHolesXMarkGRightup;
      markers.models["TypeHoles_ThreeHoles3_YMarkGRightup"+myHolesNum]=myThHolesYMarkGRightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_GRightdn"+myHolesNum]=myThHolesGRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_GRightdn"+myHolesNum]=myThHolesGRightdn;
      markers.models["TypeHoles_ThreeHoles3_GRightdn"+myHolesNum]=myThHolesGRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkGRightdn"+myHolesNum]=myThHolesMarkGRightdn;
      /*****************************************************************************/
    
    }else if(area==8){
      //画孔H位置孔
            //标记三孔 H位置孔左上
            var myThHolesHLeftup= new makerjs.models.Holes(d/2, [[xh-w/2, yh]]);
            var myThHolesMarkHLeftup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkHLeftup.origin = [xh-w/2, yh];      
            var myThHolesYMarkHLeftup = new makerjs.models.Square(0);      
            myThHolesYMarkHLeftup.origin =[xh-w/2, yh]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkHLeftup, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发X方向横向标线
     makerjs.model.addPath(myThHolesMarkHLeftup, new makerjs.paths.Line([w,0], [0, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkHLeftup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkHLeftup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesYMarkHLeftup, new makerjs.paths.Line([0,0], [0, -y0]));//X短标线
      makerjs.model.addCaption(myThHolesYMarkHLeftup, TxtY, [0-markShift, -y0], [0-markShift,0]);//X文字标注
      /*****************************************************************************/  
      /*****************************************************************************/ 
       //标记三孔H位置孔右下
       var myThHolesHRightdn= new makerjs.models.Holes(d/2, [[xh+w/2, yh]]);
            var myThHolesMarkHRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkHRightdn.origin = [xh+w/2, yh];       
            var myThHolesHMarkHRightdn = new makerjs.models.Square(0);      
            myThHolesHMarkHRightdn.origin = [xh+w/2, yh];        
            var myThHolesWMarkHRightdn = new makerjs.models.Square(0);      
            myThHolesWMarkHRightdn.origin = [xh+w/2, yh];  
      /*****************************************************************************/ 
      //makerjs.model.addPath(myThHolesMarkHRightdn, new makerjs.paths.Line([0,-h], [0, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkHRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkHRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      makerjs.model.addPath(myThHolesHMarkHRightdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkHRightdn, TxtH, [0-markShift,0], [0-markShift, h]);//Y文字标注
      makerjs.model.addPath(myThHolesWMarkHRightdn, new makerjs.paths.Line([0,0], [-w, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkHRightdn, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 F位置孔左下
       var myThHolesHLeftdn= new makerjs.models.Holes(d/2, [[xh+w/2, yh+h]]);
            var myThHolesMarkHLeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkHLeftdn.origin = [xh+w/2, yh+h]; 
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkHLeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkHLeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_HRightdn"+myHolesNum]=myThHolesHRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_HRightdn"+myHolesNum]=myThHolesHRightdn;
      markers.models["TypeHoles_ThreeHoles3_HRightdn"+myHolesNum]=myThHolesHRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkHRightdn"+myHolesNum]=myThHolesMarkHRightdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkHRightdn"+myHolesNum]=myThHolesHMarkHRightdn;
      markers.models["TypeHoles_ThreeHoles3_WMarkHRightdn"+myHolesNum]=myThHolesWMarkHRightdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_HLeftup"+myHolesNum]=myThHolesHLeftup;
      cutPlate.models["TypeHoles_ThreeHoles3_HLeftup"+myHolesNum]=myThHolesHLeftup;
      markers.models["TypeHoles_ThreeHoles3_HLeftup"+myHolesNum]=myThHolesHLeftup;
      markers.models["TypeHoles_ThreeHoles3_MarkHLeftup"+myHolesNum]=myThHolesMarkHLeftup;
      markers.models["TypeHoles_ThreeHoles3_YMarkHLeftup"+myHolesNum]=myThHolesYMarkHLeftup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_HLeftdn"+myHolesNum]=myThHolesHLeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_HLeftdn"+myHolesNum]=myThHolesHLeftdn;
      markers.models["TypeHoles_ThreeHoles3_HLeftdn"+myHolesNum]=myThHolesHLeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkHLeftdn"+myHolesNum]=myThHolesMarkHLeftdn;
      /*****************************************************************************/ 
      /*****************************************************************************/ 
    
    }else if(area==9){
            //画孔I位置孔
            //标记三孔 I位置孔右上
            var myThHolesIRightup= new makerjs.models.Holes(d/2, [[xi, yi]]);
            var myThHolesMarkIRightup = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkIRightup.origin = [xi, yi];      
            var myThHolesWMarkIRightup = new makerjs.models.Square(0);      
            myThHolesWMarkIRightup.origin =[xi, yi];       
            var myThHolesXMarkIRightup = new makerjs.models.Square(0);      
            myThHolesXMarkIRightup.origin =[xi, yi];       
            var myThHolesYMarkIRightup = new makerjs.models.Square(0);      
            myThHolesYMarkIRightup.origin =[xi, yi];    
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkIRightup, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkIRightup, new makerjs.paths.Line([0,0], [x0,0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myThHolesMarkIRightup, new makerjs.paths.Line([-w,0], [0, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkIRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkIRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesWMarkIRightup, new makerjs.paths.Line([-w,0], [0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesWMarkIRightup, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesXMarkIRightup, new makerjs.paths.Line([0,0], [x0, 0]));//X短标线
      makerjs.model.addCaption(myThHolesXMarkIRightup, TxtX, [0,0+markShift], [x0, 0+markShift]);//X文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myThHolesYMarkIRightup, new makerjs.paths.Line([0,0], [0, -y0]));//X短标线
      makerjs.model.addCaption(myThHolesYMarkIRightup, TxtY, [0-markShift,-y0], [0-markShift, 0]);//X文字标注
      /*****************************************************************************/  
      /*****************************************************************************/  
      /*****************************************************************************/ 
       //标记三孔I位置孔左下
       var myThHolesILeftdn= new makerjs.models.Holes(d/2, [[xi-w, yi]]);
            var myThHolesMarkILeftdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkILeftdn.origin = [xi-w, yi];       
            var myThHolesHMarkILeftdn = new makerjs.models.Square(0);      
            myThHolesHMarkILeftdn.origin = [xi-w, yi];  
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkILeftdn, new makerjs.paths.Line([0,0], [0, h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkILeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkILeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      makerjs.model.addPath(myThHolesHMarkILeftdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
      makerjs.model.addCaption(myThHolesHMarkILeftdn, TxtH, [0-markShift,0], [0-markShift, h]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
       //标记三孔 I位置孔右下
       var myThHolesIRightdn= new makerjs.models.Holes(d/2, [[xi-w, yi+h]]);
            var myThHolesMarkIRightdn = new makerjs.models.Square(0); //孔的原点       
            myThHolesMarkIRightdn.origin = [xi-w, yi+h];
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      makerjs.model.addPath(myThHolesMarkIRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myThHolesMarkIRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/
      plate.models["TypeHoles_ThreeHoles3_ILeftdn"+myHolesNum]=myThHolesILeftdn;
      cutPlate.models["TypeHoles_ThreeHoles3_ILeftdn"+myHolesNum]=myThHolesILeftdn;
      markers.models["TypeHoles_ThreeHoles3_ILeftdn"+myHolesNum]=myThHolesILeftdn;
      markers.models["TypeHoles_ThreeHoles3_MarkILeftdn"+myHolesNum]=myThHolesMarkILeftdn;
      markers.models["TypeHoles_ThreeHoles3_HMarkILeftdn"+myHolesNum]=myThHolesHMarkILeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_IRightup"+myHolesNum]=myThHolesIRightup;
      cutPlate.models["TypeHoles_ThreeHoles3_IRightup"+myHolesNum]=myThHolesIRightup;
      markers.models["TypeHoles_ThreeHoles3_IRightup"+myHolesNum]=myThHolesIRightup;
      markers.models["TypeHoles_ThreeHoles3_MarkIRightup"+myHolesNum]=myThHolesMarkIRightup;
      markers.models["TypeHoles_ThreeHoles3_WMarkIRightup"+myHolesNum]=myThHolesWMarkIRightup;
      markers.models["TypeHoles_ThreeHoles3_XMarkIRightup"+myHolesNum]=myThHolesXMarkIRightup;
      markers.models["TypeHoles_ThreeHoles3_YMarkIRightup"+myHolesNum]=myThHolesYMarkIRightup;
      /*****************************************************************************/ 
      plate.models["TypeHoles_ThreeHoles3_IRightdn"+myHolesNum]=myThHolesIRightdn;
      cutPlate.models["TypeHoles_ThreeHoles3_IRightdn"+myHolesNum]=myThHolesIRightdn;
      markers.models["TypeHoles_ThreeHoles3_IRightdn"+myHolesNum]=myThHolesIRightdn;
      markers.models["TypeHoles_ThreeHoles3_MarkIRightdn"+myHolesNum]=myThHolesMarkIRightdn;
      /*****************************************************************************/ 
          
  }
/*****************************************************************************/ 

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default ThreeHoles3;